<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('name')">
				Navn
			</th>
			<th class="sortable" @click="editPersonGroup(persongroupID)">
				Rediger gruppe
			</th>
			<th class="sortable" @click="sort('info')">
				Info
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(person, index) in (sortedActivity, filteredList)" :key="index" @click="editPerson(person)">
					<td v-text="person.name"></td>
					<td></td>
					<td v-text="person.info"></td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(person, index) in (sortedActivity, filteredList)" :key="index" @click="editPerson(person)">
					<td>
						<ul class="flex-content">
							<li data-label="Navn">{{ person.name }}</li>
							<li data-label="Info">{{ person.info }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen personer fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen personer
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "PersonGroupShow",
		data: () => ({
			data: [],
			customerID: null,
			persongroupID: null,
			agreementID: null,
			currentSort: "name",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html

				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var persons = this.data
				return persons.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var persons = this.data
				return persons.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					return name;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		mounted()
		{
			this.customerID = this.$route.params.customerid
			this.persongroupID = this.$route.params.persongroupid
			this.agreementID = this.$route.params.agreementid
			this.loadData()
		},
		methods:
		{
			getFullname(person)
			{
				return person.information.firstname + " " + person.information.lastname
			},
			async loadData()
			{
				this.setComponentAsBusy()
				await this.$store.dispatch(types.ACTION_GET_PERSONS, { customerid: this.customerID, agreementid: this.agreementID, persongroupid: this.persongroupID })
					.then(response =>
					{
						this.data = response.data;
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("PersonGroupShow.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},
			editPersonGroup(persongroupID)
			{
				this.$router.push({ name: "PersonGroupEdit", params: { persongroupid: persongroupID } })
			},
			editPerson(person)
			{
				this.$router.push({ name: "PersonEdit", params: { personid: person.id, persongroupid: this.persongroupID, customerid: this.customerID } })
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
